import { Tag } from 'antd';

const yesNoLabels = {
  true: 'Yes',
  false: 'No',
};

function BooleanIcons({ value, label }: { value: any; label?: string }) {
  if (value === null) {
    return '-';
  }

  switch (typeof value) {
    case 'boolean':
      return value ? (
        <Tag color="green" icon={<div>Yes</div>}>
          {label}
        </Tag>
      ) : (
        <Tag color="orange" icon={<div>No</div>}>
          {label}
        </Tag>
      );
    case 'number':
      return value === 1 ? (
        <Tag color="green" icon={<div>{yesNoLabels[value]}</div>}>
          {label}
        </Tag>
      ) : (
        <Tag color="orange" icon={<div>{yesNoLabels[value]}</div>}>
          {label}
        </Tag>
      );
    case 'string':
      return value === '1' ? (
        <Tag color="green" icon={<div>{yesNoLabels[value]}</div>}>
          {label}
        </Tag>
      ) : (
        <Tag color="orange" icon={<div>{yesNoLabels[value]}</div>}>
          {label}
        </Tag>
      );
    default:
      return '-';
  }
}

export default BooleanIcons;
